import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  description:
    "To get an audible time signal, the signal needs to be transformed back to time domain with the IFFT. Now the final signal is obtained, please listen to the convolved block. It now contains signals features as well as features of the impulse response.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 3,
      rows: 4,
      rowsSize: [1, 1, 3, 1],
      colsSize: [1, 2, 2],
      colSpan: {
        "2:0": 3,
      },
      components: [
        [null],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  formatter: "html",
                  data: "<b>Time domain</b>",
                  scrollbars: false,
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  url: `${config.ASSETS_URL}/03/18/principle/slide-04.wav`,
                  text: "play sound",
                  icon: "cis-volume-high",
                  theme: "secondary",
                  shape: "round",
                  size: "large",
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/18/principle/slide-04.svg`,
                  scrollbars: false,
                  styles: {
                    padding: "0 5%",
                  },
                },
              },
            },
          },
        ],
        [null],
      ],
    },
  },
};

export default principle;
